import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatTabsModule } from "@angular/material/tabs";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { MatButtonModule } from "@angular/material/button";
import { MatInputModule } from "@angular/material/input";
import { MatBadgeModule } from "@angular/material/badge";
import { MainLayoutComponent } from "./app-layout/main-layout/main-layout.component";
import { AuthLayoutComponent } from "./app-layout/auth-layout/auth-layout.component";
import { HeaderComponent } from "./header/header.component";
import { RightSidebarComponent } from "./right-sidebar/right-sidebar.component";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { RouterModule, Routes } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";

import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { FeatherIconsModule } from "../shared/feather-icons.module";
import { NgScrollbarModule } from "ngx-scrollbar";
import { SharedModule } from "../shared/shared.module";
// import { SharedModule } from "../shared/shared.module";
import { NgxPermissionsModule } from 'ngx-permissions';
const routes: Routes = [

  // {
  //   path:"a",
  //   component:DocumentDashboardComponent,
  // }
];
@NgModule({
  imports: [
    FeatherIconsModule,
    NgScrollbarModule,
    CommonModule,
    MatTabsModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    MatBadgeModule,
    RouterModule.forChild(routes),
    // BrowserModule,
    SharedModule,
     NgxPermissionsModule,
    
  ],
  declarations: [
    HeaderComponent,
    SidebarComponent,
    RightSidebarComponent,
    MainLayoutComponent,
    AuthLayoutComponent,
  ],
  exports: [
    // MainLayoutComponent
    HeaderComponent,
    SidebarComponent,
  ]
})
export class LayoutModule { }
